/* List of components in alphabetical order */
// Button Landing Page
import ButtonLandingMobileContent from 'org/modules/Button/ButtonLanding/components/ButtonLandingMobileContent';
// My Account
import TransactionsTabDisclaimer from 'org/modules/Profile/TransactionsTabDisclaimer/TransactionsTabDisclaimer';

export default {
  // Button Landing Page
  ButtonLandingMobileContent,
  // My Account
  TransactionsTabDisclaimer,
};
